<template>


    <!-- preloader start -->
    <div id="pre-load">
        <div id="loader" class="loader">
            <div class="loader-container has-theme-blue">
                <div class="loader-icon"><img src="assets/images/favicon-blue.png" alt=""></div>
            </div>
        </div>
    </div>
    <!-- preloader end -->

    <!-- preloader start -->

    <div id="rs-mouse">
        <div id="cursor-ball"></div>
    </div>

    <!-- preloader end -->

    <!-- Header area start -->
    <header>
        <div class="rs-header-area rs-header-one has-theme-blue rs-sticky" id="header-sticky">
            <div class="container-fluid g-0">
                    <div class="header-top">
               <div class="row justify-content-center justify-content-lg-between align-items-center gy-2">
                        <div class="col-auto d-none d-lg-block">
                            <div class="header-links">
                                <ul>
<li class="d-none d-xl-inline-block"><i class="bi bi-geo-alt-fill"></i>北京市西城区新街口外大街28号C座302室 </li>
   <li class="d-none d-xl-inline-block">&nbsp; <i class="bi bi-telephone-fill"></i><a href="tel:4006988915">400-6988-915</a></li>                               
                                </ul>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="header-links header-right">
                                <ul>
                                     <li>
 <a href="http://smartsentry.datascore.cn:8100/" class="ptrk" target="_blank"><i class="bi bi-globe"></i>智能哨兵云平台入口</a>
                                    </li>
                                    <li>    
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rs-header-inner">
                    <div class="rs-header-left">
                        <div class="rs-header-logo-wrapper">
                            <div class="rs-header-logo">
                                <a href="index"><img src="assets/images/logo/logo.png" alt="logo"></a>
                            </div>
                        </div>
                    </div>
                    <div class="rs-header-menu">

                        <nav id="mobile-menu" class="main-menu">
                            <ul class="multipage-menu">
                                <li class="menu-item">
                                    <a href="index">首页</a>

                                </li>
                                <!-- about menu -->
                                <li class="menu-item">
                                    <a href="products.html">产品中心</a>

                                </li>
                                <!-- page menu -->
                                <li class="menu-item-has-children">
                                    <a href="javascript:void(0)">解决方案</a>
                                    <ul class="submenu last-children">

                                        <li>
                                            <a href="solution1.html">有限空间作业智能管控方案</a>
                                        </li>

                                        <li>
                                            <a href="solution2.html">高处作业智能管控方案</a>
                                        </li>

                                    </ul>
                                </li>
                                <!-- elements menu -->
                                <li class="menu-item">
                                    <a href="case.html">客户案例</a>

                                </li>
                                <li class="menu-item">
                                    <a href="channelcooperation.html">渠道合作</a>

                                </li>
                                <li class="menu-item">
                                    <a href="aboutus.html">关于我们</a>

                                </li>
                                <li class="menu-item">
                                    <a href="resourcecenter">资源中心</a>

                                </li>
                                <li class="menu-item ">
                                    <a href="news">新闻动态</a>

                                </li>
                                <li class="menu-item active">
                                    <a href="contactus">联系我们</a>

                                </li>


                            </ul>
                        </nav>
                    </div>
                    <div class="rs-header-right">

                        <div class="rs-header-btn">
                            <a class="rs-btn has-theme-blue has-icon has-bg" href="contactus">立即体验
                                <span class="icon-box">
                                    <svg class="icon-first" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                        <path
                                            d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z">
                                        </path>
                                    </svg>
                                    <svg class="icon-second" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                        <path
                                            d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z">
                                        </path>
                                    </svg>
                                </span>
                            </a>
                        </div>
                        <div class="rs-header-hamburger has-theme-blue">
                            <div class="sidebar-toggle">
                                <a class="bar-icon" href="javascript:void(0)" @click="toggleLayer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                        fill="none">
                                        <path
                                            d="M8.55566 11H1.55566C1.29045 11 1.03609 11.1054 0.848557 11.2929C0.661021 11.4804 0.555664 11.7348 0.555664 12V19C0.555664 19.2652 0.661021 19.5196 0.848557 19.7071C1.03609 19.8946 1.29045 20 1.55566 20H8.55566C8.82088 20 9.07523 19.8946 9.26277 19.7071C9.45031 19.5196 9.55566 19.2652 9.55566 19V12C9.55566 11.7348 9.45031 11.4804 9.26277 11.2929C9.07523 11.1054 8.82088 11 8.55566 11ZM7.55566 18H2.55566V13H7.55566V18ZM19.5557 0H12.5557C12.2904 0 12.0361 0.105357 11.8486 0.292893C11.661 0.48043 11.5557 0.734784 11.5557 1V8C11.5557 8.26522 11.661 8.51957 11.8486 8.70711C12.0361 8.89464 12.2904 9 12.5557 9H19.5557C19.8209 9 20.0752 8.89464 20.2628 8.70711C20.4503 8.51957 20.5557 8.26522 20.5557 8V1C20.5557 0.734784 20.4503 0.48043 20.2628 0.292893C20.0752 0.105357 19.8209 0 19.5557 0ZM18.5557 7H13.5557V2H18.5557V7ZM19.5557 11H12.5557C12.2904 11 12.0361 11.1054 11.8486 11.2929C11.661 11.4804 11.5557 11.7348 11.5557 12V19C11.5557 19.2652 11.661 19.5196 11.8486 19.7071C12.0361 19.8946 12.2904 20 12.5557 20H19.5557C19.8209 20 20.0752 19.8946 20.2628 19.7071C20.4503 19.5196 20.5557 19.2652 20.5557 19V12C20.5557 11.7348 20.4503 11.4804 20.2628 11.2929C20.0752 11.1054 19.8209 11 19.5557 11ZM18.5557 18H13.5557V13H18.5557V18ZM8.55566 0H1.55566C1.29045 0 1.03609 0.105357 0.848557 0.292893C0.661021 0.48043 0.555664 0.734784 0.555664 1V8C0.555664 8.26522 0.661021 8.51957 0.848557 8.70711C1.03609 8.89464 1.29045 9 1.55566 9H8.55566C8.82088 9 9.07523 8.89464 9.26277 8.70711C9.45031 8.51957 9.55566 8.26522 9.55566 8V1C9.55566 0.734784 9.45031 0.48043 9.26277 0.292893C9.07523 0.105357 8.82088 0 8.55566 0ZM7.55566 7H2.55566V2H7.55566V7Z"
                                            fill="#616161"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <!-- Header area end -->


    <!-- Offcanvas area start -->
    <div class="fix" v-if="isShow">
        <div class="offcanvas-area has-theme-blue info-open" data-lenis-prevent>
            <div class="offcanvas-wrapper">
                <div class="offcanvas-content">
                    <div class="offcanvas-top d-flex justify-content-between align-items-center mb-25">
                        <div class="offcanvas-logo">
                            <a href="index"><img src="assets/images/logo/logo.png" alt="logo"></a>
                        </div>
                        <div class="offcanvas-close">
                            <button class="offcanvas-close-icon animation--flip" @click="toggleLayer">
                                <span class="offcanvas-m-lines">
                                    <span class="offcanvas-m-line line--1"></span><span
                                        class="offcanvas-m-line line--2"></span><span
                                        class="offcanvas-m-line line--3"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div class="offcanvas-about mb-30 d-none d-sm-block">
                        <p>北京大唐思拓信息技术有限公司成立于2006年。自创立之初，我们便坚定地投身于中国的安全生产管理事业。历经近二十年的深耕与发展，我们从最初的安全管理信息化系统研发与服务，逐步成长为今天集深厚行业经验与前沿AI技术于一体的国家级高新技术企业。我们是国内领先的人工智能与物联网（AIoT）解决方案提供商，更是您值得信赖的、懂业务的资深安全伙伴。
                        </p>
                    </div>

                    <div class="mobile-menu mean-container">
                        <div class="mean-bar">
                            <nav class="mean-nav">
                                <ul class="multipage-menu">
                                    <li class="menu-item">
                                        <a href="default.html">首页</a>

                                    </li>
                                    <!-- about menu -->
                                    <li class="menu-item active">
                                        <a href="products.html" class="active">产品中心</a>

                                    </li>
                                    <!-- page menu -->
                                    <li class="menu-item">
                                        <a href="javascript:void(0)">解决方案</a>
                                        <ul class="submenu last-children">

                                            <li>
                                                <a href="solution1.html">有限空间作业智能管控方案</a>
                                            </li>

                                            <li>
                                                <a href="solution2.html">高处作业智能管控方案</a>
                                            </li>

                                        </ul>
                                        <a class="mean-expand" href="#" style="font-size: 18px"><i
                                                class="fa-regular fa-plus"></i></a>
                                    </li>
                                    <!-- elements menu -->
                                    <li class="menu-item">
                                        <a href="case.html">客户案例</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="channelcooperation.html">渠道合作</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="aboutus.html">关于我们</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="resourcecenter">资源中心</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="news">新闻动态</a>

                                    </li>
                                    <li class="menu-item mean-last">
                                        <a href="contactus">联系我们</a>

                                    </li>


                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div class="offcanvas-contact mb-30">
                        <h4 class="offcanvas-title-meta">联系我们</h4>
                        <ul>
                            <li class="d-flex align-items-center gap-15">
                                <div class="offcanvas-contact-icon">
                                    <i class="bi bi-geo-alt-fill"></i>
                                </div>
                                <div class="offcanvas-contact-text">
                                    <a href="#">北京市西城区新街口外大街 28号C座 302 室 </a>
                                </div>
                            </li>
                            <li class="d-flex align-items-center gap-15">
                                <div class="offcanvas-contact-icon">
                                    <i class="bi bi-telephone-fill"></i>
                                </div>
                                <div class="offcanvas-contact-text">
                                    <a href="tel:400-6988-915">400-6988-915 </a>
                                </div>
                            </li>

                        </ul>
                    </div>
                    <div class="offcanvas-social">
                        <h4 class="offcanvas-title-meta">关注我们</h4>
                        <ul>
                            <li><a href="assets/images/weibo.jpg"> <img
                                        src="assets/images/weibo.jpg"><label>微博</label></a></li>
                            <li><a href="assets/images/bjh.jpg"><img src="assets/images/bjh.jpg"><label>百家号</label></a>
                            </li>
                            <li><a href="assets/images/code.jpg"><img
                                        src="assets/images/code.jpg"><label>微信公众号</label></a></li>
                            <li><a href="assets/images/douyin.jpg"><img
                                        src="assets/images/douyin.jpg"><label>抖音</label></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="offcanvas-overlay overlay-open"></div>
        <div class="offcanvas-overlay-white"></div>
    </div>

    <!-- Offcanvas area start -->

    <!-- Body main wrapper start -->
    <main class="homemain">

        <!-- breadcrumb area start -->
        <section class="rs-breadcrumb-area rs-breadcrumb-one p-relative">
            <div class="rs-breadcrumb-bg" style="background-image: url(assets/images/bg/breadcrumb-bg-01.png);"></div>
            <div class="container">
                <div class="row">
                    <div class="col-xxl-6 col-xl-8 col-lg-8">
                        <div class="rs-breadcrumb-content-wrapper">
                            <div class="rs-breadcrumb-title-wrapper">
                                <h1 class="rs-breadcrumb-title">联系我们</h1>
                            </div>
                            <div class="rs-breadcrumb-menu">
                                <nav>
                                    <ul>
                                        <li><span><a href="index">网站首页</a></span></li>
                                        <li><span>联系我们</span></li>

                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- breadcrumb area end -->




        <!-- contact form area start -->
        <!-- <section class="rs-contact-form-area rs-contact-ten section-space-bottom" style="padding-top: 80px;">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-12">
                        <div class="rs-contact-form">
                            <h3 class="rs-contact-form-title">预约演示</h3>
                            <p class="descrip">用户填写资料 → 后台审核 → 自动发自助演示 → 一对一的工程师演示</p>
                            <form id="contact-form" action="assets/mailer.php" method="POST">


 

                                <div class="row g-5">
                                        <div class="col-md-12">
                                        <div class="rs-contact-input">
                                            <input id="name" name="name" type="text" placeholder="单位名称">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="rs-contact-input">
                                            <input id="name" name="name" type="text" placeholder="联系人（必填）">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="rs-contact-input">
                                            <input id="email" name="email" type="email" placeholder="电话（必填）">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="rs-contact-input">
                                            <input id="phone" name="phone" type="text" placeholder="邮箱">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="rs-contact-input">
                                            <textarea id="message" name="message" placeholder="留言（必填）"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="rs-contact-btn">
                                            <button type="submit" class="rs-btn has-theme-orange">提交</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div id="form-messages"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <!-- contact form area end -->

        <section class="rs-contact-form-area rs-contact-ten section-space-bottom" style="padding-top: 80px;">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-12">
                        <div class="rs-contact-form">
                            <h3 class="rs-contact-form-title">预约演示</h3>
                            <p class="descrip">用户填写资料 → 后台审核 → 自动发自助演示 → 一对一的工程师演示</p>
                            <form id="contact-form" @submit.prevent="handleSubmit">
                                <div class="row g-5">
                                    <div class="col-md-12">
                                        <div class="rs-contact-input">
                                            <input v-model="form.companyName" type="text" placeholder="单位名称">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="rs-contact-input">
                                            <input v-model="form.linkName" type="text" placeholder="联系人（必填）" required>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="rs-contact-input">
                                            <input v-model="form.linkPhone" type="tel" placeholder="电话（必填）" required>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="rs-contact-input">
                                            <input v-model="form.email" type="email" placeholder="邮箱">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="rs-contact-input">
                                            <textarea v-model="form.message" placeholder="留言（必填）" required></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="rs-contact-btn">
                                            <button type="submit" class="rs-btn has-theme-orange" :disabled="isLoading">
                                                {{ isLoading ? '提交中...' : '提交' }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <!-- 显示提交消息 -->
                            <div id="form-messages" v-if="showMessage"
                                :class="submitMessage.includes('成功') ? 'success' : 'error'">
                                {{ submitMessage }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <section class="rs-contact-area section-space rs-contact-nine"
            style="background-color: #f9f9f9; padding-top:80px; ">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-6 col-lg-6">
                        <div class="rs-section-title-wrapper text-center section-title-space">

                            <h2 class="rs-section-title has-theme-blue rs-split-text-enable split-in-fade">联系我们</h2>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="rs-contact-wrapper">
                            <div class="rs-contact-item">
                                <div class="rs-contact-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22"
                                        fill="none">
                                        <path
                                            d="M9 18.8995L13.9497 13.9497C16.6834 11.2161 16.6834 6.78392 13.9497 4.05025C11.2161 1.31658 6.78392 1.31658 4.05025 4.05025C1.31658 6.78392 1.31658 11.2161 4.05025 13.9497L9 18.8995ZM9 21.7279L2.63604 15.364C-0.87868 11.8492 -0.87868 6.15076 2.63604 2.63604C6.15076 -0.87868 11.8492 -0.87868 15.364 2.63604C18.8787 6.15076 18.8787 11.8492 15.364 15.364L9 21.7279ZM9 11C10.1046 11 11 10.1046 11 9C11 7.89543 10.1046 7 9 7C7.8954 7 7 7.89543 7 9C7 10.1046 7.8954 11 9 11ZM9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13Z"
                                            fill="#737373"></path>
                                    </svg>
                                </div>
                                <div class="rs-contact-content">
                                    <h5 class="rs-contact-title">公司地址 </h5>
                                    <a href="#">北京市西城区新街口外大街28号C座302室</a>
                                </div>
                            </div>


                            <div class="rs-contact-item">
                                <div class="rs-contact-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512"
                                        height="512">
                                        <path
                                            d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z">
                                        </path>
                                        <path
                                            d="M12,6a1,1,0,0,0-1,1v4.325L7.629,13.437a1,1,0,0,0,1.062,1.7l3.84-2.4A1,1,0,0,0,13,11.879V7A1,1,0,0,0,12,6Z">
                                        </path>
                                    </svg>
                                </div>
                                <div class="rs-contact-content">
                                    <h5 class="rs-contact-title">办公时间</h5>
                                    <p> 周一至周五8:30-17:00 <br>周末及法定节假日休息 </p>
                                </div>
                            </div>





                            <div class="rs-contact-item">
                                <div class="rs-contact-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"
                                        fill="none">
                                        <path
                                            d="M23.7225 18.5848C23.1074 17.9453 22.3655 17.6034 21.5792 17.6034C20.7993 17.6034 20.051 17.9389 19.4106 18.5784L17.4068 20.573C17.242 20.4843 17.0771 20.402 16.9186 20.3197C16.6903 20.2057 16.4747 20.0981 16.2908 19.9841C14.4139 18.7937 12.7081 17.2424 11.0722 15.2353C10.2795 14.2348 9.74688 13.3927 9.36008 12.5379C9.88004 12.063 10.362 11.5691 10.8312 11.0943C11.0087 10.917 11.1863 10.7333 11.3638 10.556C12.6955 9.22637 12.6955 7.50412 11.3638 6.17444L9.63274 4.44585C9.43617 4.24957 9.23326 4.04695 9.04303 3.84433C8.66256 3.45176 8.26308 3.04652 7.85091 2.66662C7.23583 2.05876 6.50028 1.73584 5.72667 1.73584C4.95307 1.73584 4.20483 2.05876 3.57072 2.66662C3.56438 2.67295 3.56438 2.67295 3.55804 2.67928L1.40209 4.85109C0.590443 5.66156 0.127549 6.64932 0.0260924 7.79538C-0.126092 9.64427 0.419236 11.3665 0.837743 12.4936C1.86499 15.2606 3.39952 17.825 5.68862 20.573C8.46599 23.8845 11.8077 26.4995 15.625 28.3421C17.0834 29.0323 19.0301 29.8491 21.2051 29.9884C21.3383 29.9947 21.4778 30.001 21.6046 30.001C23.0694 30.001 24.2995 29.4755 25.2634 28.4307C25.2697 28.4181 25.2824 28.4117 25.2887 28.3991C25.6185 28.0002 25.9989 27.6393 26.3984 27.253C26.6711 26.9934 26.9501 26.7212 27.2227 26.4362C27.8505 25.784 28.1802 25.0242 28.1802 24.2454C28.1802 23.4603 27.8442 22.7068 27.2037 22.0736L23.7225 18.5848ZM25.9926 25.2522C25.9862 25.2522 25.9862 25.2585 25.9926 25.2522C25.7453 25.5181 25.4916 25.7587 25.219 26.0247C24.8068 26.4172 24.3883 26.8288 23.9952 27.291C23.3547 27.9749 22.6001 28.2978 21.6109 28.2978C21.5158 28.2978 21.4144 28.2978 21.3192 28.2914C19.436 28.1711 17.6858 27.4366 16.3732 26.8098C12.7842 25.0749 9.63274 22.6118 7.0139 19.4902C4.85161 16.8879 3.40586 14.4818 2.44836 11.8984C1.85865 10.3218 1.64305 9.0934 1.73817 7.93468C1.80158 7.19386 2.08692 6.57967 2.61323 6.05413L4.77552 3.89499C5.08623 3.60372 5.41596 3.44543 5.73935 3.44543C6.13884 3.44543 6.46223 3.68604 6.66514 3.88865C6.67148 3.89499 6.67782 3.90132 6.68417 3.90765C7.07097 4.26856 7.43875 4.64214 7.82555 5.04104C8.02212 5.24366 8.22503 5.44628 8.42795 5.65523L10.159 7.38381C10.8312 8.05498 10.8312 8.6755 10.159 9.34667C9.97515 9.5303 9.79761 9.71392 9.61372 9.89121C9.08107 10.4357 8.57379 10.9423 8.02212 11.4362C8.00944 11.4488 7.99676 11.4552 7.99042 11.4678C7.44509 12.0124 7.54654 12.5442 7.66068 12.9051C7.66702 12.9241 7.67336 12.9431 7.67971 12.9621C8.12992 14.0512 8.76402 15.077 9.72785 16.299L9.7342 16.3053C11.4843 18.4581 13.3296 20.1361 15.365 21.4214C15.625 21.5861 15.8913 21.719 16.145 21.8457C16.3732 21.9596 16.5888 22.0673 16.7727 22.1812C16.7981 22.1939 16.8235 22.2129 16.8488 22.2256C17.0644 22.3332 17.2673 22.3839 17.4766 22.3839C18.0029 22.3839 18.3326 22.0546 18.4404 21.947L20.609 19.7815C20.8246 19.5662 21.1671 19.3066 21.5665 19.3066C21.9597 19.3066 22.2831 19.5535 22.4796 19.7688C22.486 19.7752 22.486 19.7752 22.4923 19.7815L25.9862 23.2703C26.6394 23.9162 26.6394 24.581 25.9926 25.2522Z"
                                            fill="white"></path>
                                        <path
                                            d="M16.2163 7.13613C17.8777 7.41473 19.3869 8.19988 20.5917 9.40292C21.7964 10.606 22.5764 12.1129 22.8617 13.7719C22.9315 14.1898 23.2929 14.481 23.7051 14.481C23.7558 14.481 23.8002 14.4747 23.8509 14.4684C24.3202 14.3924 24.6309 13.9492 24.5548 13.4806C24.2124 11.4734 23.2612 9.64353 21.8091 8.19355C20.357 6.74356 18.5245 5.79379 16.5144 5.45187C16.0451 5.37589 15.6076 5.68615 15.5252 6.14837C15.4427 6.61059 15.7471 7.06015 16.2163 7.13613Z"
                                            fill="white"></path>
                                        <path
                                            d="M29.9883 13.2338C29.4239 9.92864 27.864 6.92103 25.4671 4.52761C23.0702 2.13419 20.0582 0.576563 16.7482 0.0130318C16.2853 -0.0692817 15.8478 0.247309 15.7654 0.709531C15.6893 1.17808 16 1.61498 16.4692 1.69729C19.4241 2.19751 22.1191 3.59683 24.2623 5.73065C26.4056 7.8708 27.8006 10.5618 28.3016 13.5124C28.3713 13.9303 28.7328 14.2216 29.1449 14.2216C29.1956 14.2216 29.24 14.2153 29.2908 14.2089C29.7537 14.1393 30.0707 13.6961 29.9883 13.2338Z"
                                            fill="white"></path>
                                    </svg>
                                </div>
                                <div class="rs-contact-content">
                                    <h5 class="rs-contact-title">联系我们 </h5>
                                    <a href="tel:4006988915">咨询热线：400-6988-915</a>
                                    <a href="tel:01082051185">联系电话：010-82051185</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>


        <!-- blog Style 03 -->
        <section class="rs-elements-blog-area section-space-bottom rs-blog-two vediocenter">
            <div class="container">
                <div class="row  g-5 justify-content-center section-title-space align-items-center">
                    <div class="col-xxl-8 col-xl-9 col-lg-9">
                        <div class="rs-section-title-wrapper text-center">

                            <h2 class="rs-section-title rs-split-text-enable split-in-fade">关注我们</h2>
                        </div>
                    </div>
                </div>
                <div class="row g-5">
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="rs-blog-item">
                            <div class="rs-blog-thumb1">
                                <img src="assets/images/weibo.jpg" alt="image">
                            </div>
                            <div class="rs-blog-content">
                                <h5 class="rs-blog-title underline has-black text-center">微博官方号
                                </h5>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="rs-blog-item">
                            <div class="rs-blog-thumb1">
                                <img src="assets/images/code.jpg" alt="image">
                            </div>
                            <div class="rs-blog-content">
                                <h5 class="rs-blog-title underline has-black text-center"> 微信公众号
                                </h5>
                            </div>
                        </div>
                    </div>


                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="rs-blog-item">
                            <div class="rs-blog-thumb1">
                                <img src="assets/images/douyin.jpg" alt="image">
                            </div>
                            <div class="rs-blog-content">
                                <h5 class="rs-blog-title underline has-black text-center">抖音官方号
                                </h5>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="rs-blog-item">
                            <div class="rs-blog-thumb1">
                                <img src="assets/images/bjh.jpg" alt="image">
                            </div>
                            <div class="rs-blog-content">
                                <h5 class="rs-blog-title underline has-black text-center">百家号
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <!-- blog Style 03 -->






    </main>
    <!-- Body main wrapper end -->
    <div class="rs-footer-bg-thumb-wrapper">
        <div class="rs-footer-bg-thumb" data-background="assets/images/bg/footer-bg-02.png"></div>



        <!-- Body main wrapper end -->

        <!-- footer area start -->
        <footer>
            <div class="rs-footer-area rs-footer-two has-theme-blue">
                <div class="container">
                    <div class="rs-footer-top">
                        <div class="row g-5">
                            <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                <div class="rs-footer-widget footer-2-col-1">
                                    <h5 class="rs-footer-widget-title">关于我们</h5>
                                    <div class="rs-footer-widget-content">
                                        <img src="assets/images/logo/logo1.png" style="height: 60px;" alt="">
                                        <p class="rs-footer-widget-description">
                                            智能守护安全，创新引领未来，20年的深耕与发展，领先的人工智能与物联网(AIoT)解决方案提供商，更是您值得信赖的、懂业务的资深安全伙伴。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-6">
                                <div class="rs-footer-widget footer-2-col-2">
                                    <h5 class="rs-footer-widget-title">产品与服务</h5>
                                    <div class="rs-footer-widget-content">
                                        <div class="rs-footer-widget-links has-theme-blue">
                                            <ul>
                                                <li> <a href="products.html">产品中心</a> </li>
                                                <li><a href="solution1.html">解决方案</a></li>
                                                <li><a href="case.html">客户案例</a></li>
                                                <li><a href="channelcooperation.html">寻求合作</a></li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-6">
                                <h5 class="rs-footer-widget-title">支持与资源</h5>
                                <div class="rs-footer-widget-content">
                                    <div class="rs-footer-widget-links has-theme-blue">
                                        <ul>

                                            <li> <a href="news">新闻中心</a> </li>
                                            <li><a href="resourcecenter">获取资源</a></li>
                                            <li><a href="contactus">联系我们</a></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-6 col-sm-6">
                                <div class="rs-footer-widget">
                                    <h5 class="rs-footer-widget-title">关注我们</h5>
                                    <div class="rs-footer-widget-content">

                                        <p class="rs-footer-widget-description" style="margin-bottom: 10px;">
                                            关注我们的社交媒体了解更多信息
                                        </p>
                                        <div class="rs-footer-widget-social">
                                            <div class="rs-theme-social has-theme-blue">
                                                <a href="assets/images/weibo.jpg"> <img
                                                        src="assets/images/weibo.jpg"><label>微博</label></a>
                                                <a href="assets/images/bjh.jpg"><img
                                                        src="assets/images/bjh.jpg"><label>百家号</label></a>
                                                <a href="assets/images/code.jpg"><img
                                                        src="assets/images/code.jpg"><label>微信公众号</label></a>
                                                <a href="assets/images/douyin.jpg"><img
                                                        src="assets/images/douyin.jpg"><label>抖音</label></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rs-footer-copyright-area rs-copyright-one">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-xl-8">
                                <div class="rs-footer-copyright has-theme-blue text-left">
                                    <p class="underline"> 版权所有 © <span id="year">2025</span> <a
                                            href="http://www.datascore.com" target="_blank">北京大唐思拓信息技术有限公司</a></p>
                                </div>
                            </div>
                            <div class="col-xl-4">
                                <div style="text-align: right; color: #fff;"> <a href="https://beian.miit.gov.cn/"
                                        target="_blank">京ICP备19044307号</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!-- footer area end -->

    </div>


    <!-- back to top -->
    <!-- Backtotop start -->
    <div class="backtotop-wrap cursor-pointer" @click="scrollToTop">
        <svg class="backtotop-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>

</template>

<script setup>

import { ref, onMounted, onUnmounted, nextTick,reactive } from 'vue';
import http from '@/shared/http.service';
import { Uris } from '@/shared/const';
import dayjs from 'dayjs';
import useClue from '@/composables/useClue';

onMounted(() => {
  document.title = '关于我们 - 高危作业智能哨兵厂家 - 北京大唐思拓';

  const metaKeywords = document.createElement('meta');
  metaKeywords.name = 'keywords';
  metaKeywords.content = '北京大唐思拓，国家高新技术企业，是国内领先的AIoT解决方案提供商与高危作业智能哨兵的原创发明者与核心厂家';
  document.head.appendChild(metaKeywords);

  const metaDescription = document.createElement('meta');
  metaDescription.name = 'description';
  metaDescription.content = '北京大唐思拓，国家高新技术企业，是国内领先的AIoT解决方案提供商与高危作业智能哨兵的原创发明者与核心厂家';
  document.head.appendChild(metaDescription);
  
});
// 使用线索管理
const {
    form,
    handleSave,
    resetFields
} = useClue();

  // 添加提交功能
const isLoading = ref(false);
const submitMessage = ref('');
const showMessage = ref(false);

// 处理表单提交
const handleSubmit = async (event) => {
    // 阻止表单默认提交行为
    event.preventDefault();
    
    isLoading.value = true;
    submitMessage.value = '';
    showMessage.value = false;

    try {
        // 准备表单数据
        const formData = {
            id:"",
            companyName: form.companyName,
            linkName: form.linkName,
            linkPhone: form.linkPhone,
            email: form.email,
            message: form.message,
            // 可以根据需要添加其他字段
            source: '预约演示', // 来源标识
            title: '预约演示请求'
        };

        // 调用 handleSave 方法
        await handleSave(formData);
        
        // 显示成功消息
        submitMessage.value = '提交成功！我们会尽快与您联系。';
        showMessage.value = true;
        
        // 可选：重置表单
        resetFields();
        
        // 3秒后隐藏消息
        setTimeout(() => {
            showMessage.value = false;
        }, 3000);
        
    } catch (error) {
        console.error('提交失败:', error);
        submitMessage.value = '提交失败，请稍后重试';
        showMessage.value = true;
        
        // 3秒后隐藏错误消息
        setTimeout(() => {
            showMessage.value = false;
        }, 3000);
    } finally {
        isLoading.value = false;
    }
};


// 响应式变量：控制隐藏层显示状态（默认隐藏）
const isShow = ref(false);
// 滚动到顶端的方法
const scrollToTop = () => {
  // 方法1：使用 window.scrollTo() 带平滑动画
  window.scrollTo({
    top: 0, // 滚动到顶部
    behavior: 'smooth' // 平滑滚动（关键）
  });

  // 方法2：兼容旧浏览器（手动设置滚动距离，无动画）
  // document.documentElement.scrollTop = 0
  // document.body.scrollTop = 0
};
// 切换显示状态的方法
const toggleLayer = () => {
  isShow.value = !isShow.value;
};
</script>
<style >
.rs-blog-two .rs-blog-content{
    padding: 0px !important;
}
</style>